import React from 'react';
import PropTypes from 'prop-types';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import Collapse from 'react-bootstrap/lib/Collapse';
import SimplePanel from './SimplePanel';

const CollapsablePanel = ({ title, bodyClass, collapsed, children, collapseChanged, ...rest }) => (
  <SimplePanel
    onClick={() => collapseChanged(!collapsed)}
    titleClass="pointer"
    bodyClass={bodyClass}
    title={
      <span className="pointer">
        {collapsed ? (
          <FaChevronUp className="file-icon" />
        ) : (
          <FaChevronDown className="file-icon" />
        )}
        {title}
      </span>
    }
    {...rest}
  >
    <Collapse in={!collapsed}>{children}</Collapse>
  </SimplePanel>
);

CollapsablePanel.propTypes = {
  title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.node]).isRequired,
  collapseChanged: PropTypes.func.isRequired,
  collapsed: PropTypes.bool,
  bodyClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
CollapsablePanel.defaultProps = {
  bodyClass: '',
  collapsed: true,
  children: undefined,
};

export default CollapsablePanel;
